export const ROUTES = {
  BASE_URL: process.env.PUBLIC_URL || '',
  LESSONS: 'lessons',
  LESSON: 'lessons/:id',
  COURSES: 'courses',
  COURSE: 'courses/:id',
  STORY_MODE: 'story-mode',
  AUTH: {
    LOGIN: 'login',
    REGISTER: 'register',
  },
};
